// @ts-ignore-error
import ResourceBackground from "@pathwright/ui/src/components/background/ResourceBackground"

// @ts-ignore-error
import ThemeBackground from "@pathwright/ui/src/components/background/ThemeBackground"

// @ts-ignore-error
import { useScreensizeContext } from "@pathwright/ui/src/components/ui/Screensize"

// @ts-ignore-error
import IconButton from "@pathwright/ui/src/components/button/IconButton"

import { Card } from "@pathwright/ui/src/components/card/types"
import {
  InvitationContext,
  useGroupQuery
} from "@pathwright/web/src/modules/api/generated"
import { usePathwrightContext } from "@pathwright/web/src/modules/pathwright/PathwrightContext"
import "./InvitationHeader.css"

const InvitationHeader = ({
  card,
  context
}: {
  card: Card
  context: InvitationContext | null
}) => {
  const { school } = usePathwrightContext()

  // Only supporting school and cohort context at this point (not group, though GroupQuery is "cohort").
  const groupQuery = useGroupQuery({
    variables: {
      id: context?.cohort_id!
    },
    skip: !context?.cohort_id
  })
  const cohort = groupQuery.data?.group

  const title = cohort
    ? cohort.is_source_cohort
      ? cohort.resource?.name
      : cohort.name
    : school.name

  const roundedTop = useScreensizeContext() !== "sm"
  return (
    <header className="InvitationHeader">
      {cohort?.resource ? (
        <ResourceBackground
          resource={cohort.resource}
          roundedTop={roundedTop}
        />
      ) : (
        <ThemeBackground roundedTop={roundedTop} />
      )}
      <div className="InvitationHeader__content">
        <IconButton
          icon={card.isIndex ? "x" : "arrow-left"}
          onClick={() => card.onClose()}
          inverted
        />
        <h2>Invitations to {title}</h2>
      </div>
    </header>
  )
}

InvitationHeader.displayName = "InvitationHeader"

export default InvitationHeader
